import { Component } from '@angular/core';

import { COLORS, IAnnotationColor } from '../../models/annotation';
import { MouseModeService } from '../../services/mouse-state.service';

/** Component for showing metadata about the plot data */
@Component({
    selector: 'sci-color-tools',
    template: `
        <button mat-icon-button [matMenuTriggerFor]="colorToolsMenu" matTooltip="Change annotation color">
            <mat-icon>color_lens</mat-icon>
            <div class="color-picker-selected-color" [style.background-color]="selectedColor.color"></div>
        </button>

        <mat-menu #colorToolsMenu="matMenu">
            <mat-grid-list cols="2">
                <mat-grid-tile *ngFor="let color of colors"
                               (click)="selectColor(color)"
                               [matTooltip]="color.class"
                               matTooltipPosition="after"
                               matTooltipShowDelay="500"
                >
                    <div mat-menu-item class="color-picker-menu">
                        <div class="color-picker-swatch" [style.background-color]="color.color"></div>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
        </mat-menu>
    `,
    styleUrls: [ './annotations.component.scss' ]
})
export class ColorToolsComponent  {
    colors = COLORS;
    selectedColor = COLORS[0];

    constructor( private _mouseModeService: MouseModeService ) {}

    selectColor( color: IAnnotationColor ) {
        this.selectedColor = color;
        this._mouseModeService.setAnnotationColor( color );
    }
}
